<template>
  <div class="main-container">
    <BackBtn @goBack="back"/>
    <div v-if="curCountry.length" class="country__content">
      <img :src="curCountry[0].flag" :alt="`National Flag of ${curCountry[0].name}`">
      <CountryDetails class="country-details-container" :country="curCountry[0]"/>
    </div>
    <div v-else>Fetching Data</div>
  </div>
</template>

<script>
import BackBtn from '../components/AppBackBtn'
import CountryDetails from '../components/TheCountryDetails'

export default {
    props: ['country'],
    data() {
      return {
        curCountry: [],
      }
    },
    components: { BackBtn,CountryDetails },
    methods: {
      back() {
        window.history.back()
      }
    },
    mounted() {
      fetch(`https://restcountries.eu/rest/v2/name/${this.country}?fullText=true`)
        .then(res => res.json())
        .then(data => this.curCountry = data )
        .catch(err => console.log(err))
      
    }
  
}
</script>

<style lang="scss">

.country__content {
  @media (min-width: 47.38em) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  > .country-details-container {
    
    @media (min-width: 47.38em) {
      margin-left: 2em;
      
      min-width: 20%;
    }

    @media (min-width: 58.75em) {
      min-width: 40%;
      max-width: 26.77rem;
      margin-left: 3em;
    }
    
  }
  > img {
    width: 100%;
    margin: 2rem 0;
    @media (min-width: 47.38em) {
      margin-left: 2em;
      width: 50%;
    }

    @media (min-width: 58.75em) {
      min-width: 55%;
    }
  }
}


</style>